import React, {createContext, useContext, useReducer} from 'react';

// Definition of 3 types of action
export const AUTH_ACTIONS = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT'
};

// Creation of the context with a more complete default value
// Access to the auth data
const AuthContext = createContext(null);
// Update of tje auth data with dispatch
const AuthDispatchContext = createContext(null);

// Provider of the context that will share the dispatch function
export function AuthProvider({ children }) {
    const [auth, dispatch] = useReducer(authReducer, getInitialState({}));
    
    return (
        <AuthContext.Provider value={auth}>
            <AuthDispatchContext.Provider value={dispatch}>
                {children}
            </AuthDispatchContext.Provider>
        </AuthContext.Provider>
    );
};

// Check the localStorage when the page is load
function getInitialState() {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const userId = localStorage.getItem('user_id') || sessionStorage.getItem('user_id');
    const email = localStorage.getItem('current_user_email') || sessionStorage.getItem('current_user_email');    
    
    const localRoles = localStorage.getItem('roles') ? JSON.parse(localStorage.getItem('roles')) : [];
    const sessionRoles = sessionStorage.getItem('roles') ? JSON.parse(sessionStorage.getItem('roles')) : [];    

    let roles = localRoles.length > 0 ? localRoles :
            sessionRoles.length > 0 ? sessionRoles :
            [];

    return {
        token: token,
        email: email,
        userId: userId,
        roles: roles,
        isConnected: !!(token && email)
    };
};

function authReducer(auth, action) {
    switch (action.type) {
        case AUTH_ACTIONS.LOGIN: {
            localStorage.removeItem("current_user_email");
            localStorage.removeItem("token");
            localStorage.removeItem("roles");
            localStorage.removeItem("user_id");
            localStorage.removeItem("current_company_id");
            sessionStorage.clear();

            localStorage.setItem("current_user_email", action.payload.email);
            localStorage.setItem("token", action.payload.token);
            localStorage.setItem("user_id", action.payload.userId);
            localStorage.setItem("roles", JSON.stringify(action.payload.roles));
            
            return {
                ...auth,
                token: action.payload.token,
                userId: action.payload.userId,
                email: action.payload.email,
                roles: action.payload.roles,
                isConnected: true,
            };
        }
        case AUTH_ACTIONS.LOGOUT: {            
            localStorage.removeItem("current_user_email");
            localStorage.removeItem("token");
            localStorage.removeItem("user_id");
            localStorage.removeItem("roles");
            localStorage.removeItem("current_company_id");
            sessionStorage.clear();

            return  {
                ...auth,
                token: null,
                userId: null,
                email: null,
                roles: [],
                isConnected: false
            }
        }
        default:
            return auth;
    }
}

// Creation of a hook to use the context in a component
export function useAuth() {
    return useContext(AuthContext);
};

// Creation of a hook to use the context in a component
export function useAuthDispatch() {
    return useContext(AuthDispatchContext);
};